import { BgColorsOutlined, CloseOutlined, PlusOutlined, SaveOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';
const TopHeader = (props) => {
	const { handleCustomiseWidgets, setOpen, customiseWidgets, handleSaveLayout, handleCancel, loading, data } = props;

	return (
		<div className="text-end">
			{!customiseWidgets ? (
				<>
					<Button type="primary" onClick={() => setOpen(true)} icon={<PlusOutlined />} className="mr-2">
						Add Widget
					</Button>
					{data.length > 0 && (
						<Button type="primary" onClick={handleCustomiseWidgets} icon={<BgColorsOutlined />}>
							Customize Widget
						</Button>
					)}
				</>
			) : (
				<>
					<Button
						className="mr-2"
						type="primary"
						icon={<SaveOutlined />}
						onClick={handleSaveLayout}
						loading={loading}
					>
						Save
					</Button>
					<Button onClick={handleCancel} type="primary" icon={<CloseOutlined />}>
						Cancel
					</Button>
				</>
			)}
		</div>
	);
};
export default TopHeader;
